/**
 * MuiPaper
 */
const MuiPaper = {
  defaultProps: {
    elevation: 0
  }
};
export default MuiPaper;